import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { BffService } from '../../services/BffService';
import { UserType } from '../../models/AuthUser';

@Component({
  selector: 'app-employee-login',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './employee-login.component.html',
  styleUrl: './employee-login.component.css',
})
export class EmployeeLoginComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isLoading = false;
  isAuthenticated = false;

  constructor(
    private bff: BffService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Check if user is already authenticated as employee
    /* this.dualAuthService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuth => {
        this.isAuthenticated = isAuth;
        if (isAuth && this.dualAuthService.isEmployee()) {
          this.router.navigate(['/']); // Redirect to main app
        }
      }); */
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loginWithMicrosoft(): void {
    this.isLoading = true;

    this.bff.signInEmployee();
  }

  loginWithRedirect(): void {
    this.bff.signInEmployee();
  }

  goBack(): void {
    this.router.navigate(['/login']);
  }
}
